var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aprocon-header-menu",class:{ 'open': _vm.open }},[_c('div',{staticClass:"aprocon-header-menu-background",on:{"click":_vm.close}}),_c('nav',{staticClass:"aprocon-header-menu-container"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }